import Vue from 'vue';
import Router from 'vue-router';
import Info from './views/Info.vue';
import Calculator from './views/Calculator.vue';
import Env from '@/services/env.service';
import VueGtag from 'vue-gtag';
import multiguard from 'vue-router-multiguard';
import store from '@/store';
import * as guards from './guards/';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/info'
    },
    {
      path: '/info',
      name: 'info',
      component: Info,
    },
    {
      path: '/calculator',
      name: 'calculator',
      component: Calculator,

    },
    {
      path: '/about',
      name: 'about',
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),

    },
    {
      path: '/splash',
      name: 'splash',
      component: () => import(/* webpackChunkName: "about" */ './views/Splash.vue'),
      beforeEnter:  guards.loggedOut,
      meta: { fromAuth: false, fromSplash: true, unauthorized: false }

    },
    {
      path: '/auth',
      name: 'splash',
      component: () => import(/* webpackChunkName: "about" */ './views/Splash.vue'),
      beforeEnter: multiguard([guards.newAuth, guards.hasToHaveCompanies ]),
      meta: { fromAuth: true, requiresAuth:true }

    },
    {
      // will match everything
      path: '*', redirect: '/'
    }
  ],
});


router.beforeEach(async (to, from, next) => {
   store.commit('setLoading', true);
  if (to.path === '/splash') {    
    return next();
  } 
  const isAuthed = await guards.isAuthenticated();

  store.commit('setLoading', false);

  if (isAuthed) {
    next();
  } else {
    next('/splash');
  }
});

router.afterEach(async (to, from) => {
  store.commit('setLoading', false);
});


if (Env.get('VUE_APP_GA_ID')) {
  Vue.use(VueGtag, {
    config: { id: Env.get('VUE_APP_GA_ID') }
  }, router);
}

export default router;